import React from 'react'
import { FaLinkedin, FaGithub } from 'react-icons/fa'
import { HiOutlineMail } from "react-icons/hi";
import { BsFillPersonFill } from "react-icons/bs";

const SocialLink = () => {

    const links = [
        {
           id : 1,
           child : (
            <>
              LinkedIn <FaLinkedin size={30} />
            </>
           ),
           href : 'https://www.linkedIn.com',
           style : 'rounded-tr-md'
        },
        {
           id : 2,
           child : (
            <>
              Github <FaGithub size={30} />
            </>
           ),
           href : 'https://github.com/pemanamgur',
        },
        {
           id : 3,
           child : (
            <>
              Mail <HiOutlineMail size={30} />
            </>
           ),
           href : 'mail to : pemanamgurtamang7@gmail.com',
        },
        {
           id : 4,
           child : (
            <>
              Resume <BsFillPersonFill size={30}/>
            </>
           ),
           href : '/resume.pdf',
           style : 'rounded-br-md',
           download : true,
        },
    ]

  return (
    <div className='hidden lg:flex flex-col top-[35%] left-0 fixed '>
        <ul>

{
    links.map(({id,child,style,href,download})=>(
      
            <li key={id} 
            className={`flex justify-between items-center w-40 h-14 px-4 bg-gray-500 ml-[-100px] hover:ml-[-10px] hover:rounded-lg ${style}` }>
                <a href={href} 
                className='flex text-white items-center justify-between w-full '
                download={download}
                target='_blank'
                rel='noreferrer '
                >
               {child}
               </a>
            </li>
    ))
}

        </ul>    
    </div>
  )
}

export default SocialLink
